namespace GeniuzPOS.PosShift {
    export interface PsVatRefundDtForm {
        DocNo: Serenity.StringEditor;
        RefInv: Serenity.StringEditor;
        RefTaxNo: Serenity.StringEditor;
        PluCode: Serenity.StringEditor;
        PluDesc: Serenity.StringEditor;
        Qty: Serenity.DecimalEditor;
        Amt: Serenity.DecimalEditor;
        ItemVat: Serenity.DecimalEditor;
        ItemId: Serenity.StringEditor;
        Cancel: Serenity.IntegerEditor;
    }

    export class PsVatRefundDtForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsVatRefundDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsVatRefundDtForm.init)  {
                PsVatRefundDtForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(PsVatRefundDtForm, [
                    'DocNo', w0,
                    'RefInv', w0,
                    'RefTaxNo', w0,
                    'PluCode', w0,
                    'PluDesc', w0,
                    'Qty', w1,
                    'Amt', w1,
                    'ItemVat', w1,
                    'ItemId', w0,
                    'Cancel', w2
                ]);
            }
        }
    }
}
